// FollowingStep.tsx

import React, { useContext, useEffect, useState } from 'react'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import UserContext from '../../../../contexts/UserContext'
import StockContext from '../../../../contexts/StockContext'
import io from 'socket.io-client'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  SubText,
  ListItem,
  ErrorText,
  ProgressContainer,
  ProgressFill,
  SuccessText,
  ButtonsDiv,
  FinishButton,
  DisabledFinishButton,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import cross from '../../../../assets/addStockModal/cross.svg'

const FollowingStep = () => {
  const { setImportFromExcelModal } = useContext(StockContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const [stockPercentage, setStockPercentage] = useState<number>(0)
  const [successLines, setSuccessLines] = useState<number>(0)
  const [errorLines, setErrorLines] = useState<number>(0)
  const [createdInDataBaseLines, setCreatedInDataBaseLines] =
    useState<number>(0)
  const [updatedInDataBaseLines, setUpdatedInDataBaseLines] =
    useState<number>(0)
  const [updatedInOmieLines, setUpdatedInOmieLines] = useState<number>(0)
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    if (stockPercentage === 100) {
      const timer = setTimeout(() => {
        setShowButton(true)
      }, 1000) // 3 segundos

      return () => clearTimeout(timer)
    } else {
      setShowButton(false)
    }
  }, [stockPercentage])

  useEffect(() => {
    /* const socket = io('ws://localhost:8080') */
    const socket = io('wss://interface-web-backend-hjk3p7rq3q-rj.a.run.app')  // Substitua pelo endereço do seu servidor WebSocket

    socket.on(
      'conclusionsEvent',
      ({
        createdInDatabase,
        updatedInDatabase,
        updatedInOmie,
        percentageComplete,
        success,
        error,
      }) => {
        setStockPercentage(percentageComplete)
        setSuccessLines(success)
        setErrorLines(error)
        setCreatedInDataBaseLines(createdInDatabase)
        setUpdatedInDataBaseLines(updatedInDatabase)
        setUpdatedInOmieLines(updatedInOmie)
      },
    )
  }, [])

  const ProgressBar = (props: any) => {
    const fillerStyles = {
      width: `${props.completion}%`,
    }

    return (
      <ProgressContainer>
        <ProgressFill style={fillerStyles} />
      </ProgressContainer>
    )
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Importação em andamento...</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <SubText>Esse processo pode levar alguns minutos.</SubText>
      <ProgressBar completion={stockPercentage} />
      <ul>
        <ListItem>
          Linhas processadas com <SuccessText>sucesso</SuccessText>:{' '}
          {successLines}
        </ListItem>
        <ListItem>
          Linhas processadas com <ErrorText>erro</ErrorText>: {errorLines}
        </ListItem>
        <ListItem>
          Linhas criadas com sucesso no banco: {createdInDataBaseLines}
        </ListItem>
        <ListItem>
          Linhas atualizadas com sucesso no banco: {updatedInDataBaseLines}
        </ListItem>
        <ListItem>
          Linhas atualizadas com sucesso na omie: {updatedInOmieLines}
        </ListItem>
      </ul>
      <ButtonsDiv>
        {showButton ? (
          <FinishButton onClick={() => window.location.reload()}>
            Concluir
          </FinishButton>
        ) : (
          <DisabledFinishButton>Concluir</DisabledFinishButton>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default FollowingStep
